import { useGetManagerProfile } from "manager/hooks/api";

/**
 * Hook to check if the current user has a "View Only" role.
 * This is used to hide certain actions in the UI for view-only users.
 */
export const useIsViewOnlyUser = () => {
  const { data: profile, isLoading } = useGetManagerProfile();

  // The backend ManagerProfileSerializer returns profile.role as a string
  const roleName = profile?.role;
  const isViewOnly = !!roleName && roleName.toLowerCase().includes("view only");

  return {
    isViewOnly,
    isLoading,
  };
};

export default useIsViewOnlyUser;
